import { createFeatureSelector, createSelector } from '@ngrx/store';
import type { INewRelicInteractionState } from './newrelic-interaction.reducer';
import * as fromReducer from './newrelic-interaction.reducer';

const getNewRelicInteractionState =
  createFeatureSelector<INewRelicInteractionState>('newRelicInteraction');

export const getNewRelicInteractionId = createSelector(
  getNewRelicInteractionState,
  fromReducer.getNewRelicInteractionId
);
